import type { ReactNode } from "react";
import { DEFAULT_ACCENT_COLOR } from "@/lib/accentColor";
import { cn } from "@/lib/utils";

/** Gold pill that marks the sale, same colours as the "New" pill but larger. */
export function SaleBadge({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) {
  return (
    <span
      className={cn(
        "inline-block rounded-full px-3 py-1 text-sm font-semibold leading-none text-white whitespace-nowrap",
        className,
      )}
      style={{ backgroundColor: DEFAULT_ACCENT_COLOR }}
    >
      {children}
    </span>
  );
}
